import React, { Suspense, /*lazy,*/ useState, useRef, useEffect } from "react";
import { Redirect, Switch, Route  } from "react-router-dom";
// import { useBeforeunload } from 'react-beforeunload';
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { LayoutSplashScreen, ContentRoute } from "../_metronic/layout";

import { uiSagaActions } from "./modules/UI";

import { HelpPage } from "./modules/Help";
import { DashboardPage } from "./modules/Dashboard";
import { ReceiptManagement } from "./modules/ReceiptManagement";
import { ReceiptTracking } from "./modules/ReceiptTracking";
import { ReportManagement } from "./modules/Reporting";
// import { RefundValidation } from "./modules/RefundValidation";
import SessionTimeoutModal from "./components/SessionTimeoutModal";

import IdleTimer from "react-idle-timer";
import { Alert, Fade } from "react-bootstrap";
// import { authSagaActions } from "./modules/Auth";

// const UserManagement = lazy(() =>
//   import("./modules/Administration/UserManagement/pages/UserManagement"));

let countdownInterval;
let timeout;

export default function BasePage() {

  const dispatch = useDispatch();
  const history = useHistory();

  const { ui } = useSelector(state => state);

  const { notification, showNotification, errorStatus, errorMsg } = ui;

  const [ errorOccured, setErrorOccurred ] = useState(false);

  useEffect(() => {
    if (showNotification){
      setErrorOccurred(true);
      setTimeout(() => {
        setErrorOccurred(false);
        dispatch(uiSagaActions.hideNotifications());
      }, 5000);
    } else {
      setErrorOccurred(false);
    }
  }, [showNotification, dispatch]);

  const closeAlert = () => {
    dispatch(uiSagaActions.hideNotifications());
    setErrorOccurred(false);
  };

  const clearSessionTimeout = () => {
    clearTimeout(timeout);
  };

  const clearSessionInterval = () => {
    clearInterval(countdownInterval);
  };

  const handleLogout = async () => {
    try {
      setTimeoutModalOpen(false);
      clearSessionInterval();
      clearSessionTimeout();
      history.push("/logout");
    } catch (err) {
      console.error(err);
    }
  };

  const handleContinue = () => {
    setTimeoutModalOpen(false);
    clearSessionInterval();
    clearSessionTimeout();
  };

  const onActive = () => {
    if (!timeoutModalOpen) {
      clearSessionInterval();
      clearSessionTimeout();
    }
  };

  const onIdle = () => {

    const delay = 1000 * 1;

    if (!timeoutModalOpen) {

      timeout = setTimeout(() => {
        let countDown = 15;
        setTimeoutModalOpen(true);
        setTimeoutCountdown(countDown);
        countdownInterval = setInterval(() => {
          if (countDown > 0) {
            setTimeoutCountdown(--countDown);
          } else {
            handleLogout(true);
          }
        }, 1000);
      }, delay);
    }
  };

  const [timeoutModalOpen, setTimeoutModalOpen] = useState(false);
  const [timeoutCountdown, setTimeoutCountdown] = useState(0);
  const idleTimer = useRef(null);

 //delete session record when the browser closes
 //  useBeforeunload(() => {
  //   dispatch(authSagaActions.logout());
  //  });

  return (
    <Suspense fallback={<LayoutSplashScreen />} >

      {
        errorOccured ?
        <div className="d-flex justify-content-end">
          <Alert variant="danger" transition={Fade} onClose={closeAlert} dismissible style={{ width: "40%", zIndex: 2, position: "absolute" }} >
            <Alert.Heading > {notification.message} </Alert.Heading>
            <p>
              <b>{errorStatus} {errorMsg} </b> Looks like an unexpected error has occured.
              <br/>
              Check the Help page if you need further assistance.
            </p>
          </Alert>
        </div>
        : null  
      }

      <IdleTimer
        ref={idleTimer}
        onActive={onActive}
        onIdle={onIdle}
        debounce={250}
        timeout={300000}

      />

      <SessionTimeoutModal
        countdown={timeoutCountdown}
        onContinue={handleContinue}
        onLogout={handleLogout}
        open={timeoutModalOpen}
      />

      <Switch>
        {
          <Redirect exact from="/" to="/dashboard" />
        }
        <ContentRoute path="/dashboard" component={DashboardPage} />
        <ContentRoute path="/receipt-management" component={ReceiptManagement} />
        <ContentRoute path="/receipt-tracking" component={ReceiptTracking} />
        {/* <ContentRoute path="/refund-validation" component={RefundValidation} /> */}
        <ContentRoute path="/reporting" component={ReportManagement} />
        <Route path="/help" component={HelpPage} />

        <Redirect to="error/error-v1" />
      </Switch>
    </Suspense>
  );
}
